import { Subject } from 'rxjs/Rx';
import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class UserSharedService {
  public subject = new Subject();
  @Output() onUserCreate: EventEmitter<any> = new EventEmitter();
  @Output() onUserUpdated: EventEmitter<any> = new EventEmitter();
  @Output() onTicketUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onTicketCreate: EventEmitter<any> = new EventEmitter();
  @Output() onChangetab: EventEmitter<any> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/customer/UserSharedService.ts